export function pick(obj, fields) {
    var res = {};
    if (Array.isArray(fields)) {
        fields.forEach(function (key) {
            res[key] = obj[key];
        });
    }
    return res;
}
